/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 632309be6dea
 */

import * as z from "zod";
import { Info, Info$zodSchema } from "./info.js";

export type ListResponse = {
  resources?: Array<Info> | undefined;
  next_cursor?: string | null | undefined;
  total_count?: number | undefined;
};

export const ListResponse$zodSchema: z.ZodType<ListResponse> = z.object({
  next_cursor: z.string().nullable().optional(),
  resources: z.array(Info$zodSchema).optional(),
  total_count: z.int().optional(),
});
